import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addSubtest } from "./reducers/ruleFrameSlice";

import { TextField, MenuItem, Box, Button } from "@mui/material";

export default function BloodTestsManager({ categoryId }) {
  const dispatch = useDispatch();
  const { selectedCategory } = useSelector((state) => state.s1RuleFrame);

  const [testName, setTestName] = useState("");
  const [minAge, setMinAge] = useState("");
  const [maxAge, setMaxAge] = useState("");
  const [gender, setGender] = useState("Both");

  const handleAdd = () => {
    dispatch(
      addSubtest({
        category: categoryId,
        sub_test_name: testName,
        min_age: minAge,
        max_age: maxAge,
        gender,
      }),
    );
    setTestName("");
    setMinAge("");
    setMaxAge("");
    setGender("Both");
  };

  const isAgeInvalid =
    minAge !== "" &&
    maxAge !== "" &&
    parseInt(minAge, 10) >= parseInt(maxAge, 10);

  const isDisabled = !testName.trim() || isAgeInvalid;
  return (
    <>
      <Box
        sx={{
          display: "flex",
          gap: 2,
          flexWrap: "wrap",
          alignItems: "center",
          mb: "10px",
        }}
      >
        <TextField
          label={`Enter a new Pathology Test for Category - ${selectedCategory || ""}`}
          value={testName}
          onChange={(e) => setTestName(e.target.value)}
          sx={{
            flex: 2,
            minWidth: 280,
            "& .MuiInputLabel-root": {
              top: "-16px",
            },

            "& .MuiInputBase-input": {
              fontSize: "0.85rem",
              padding: "2px 6px",
            },
          }}
        />
        <TextField
          label="Min Age"
          value={minAge}
          onChange={(e) => setMinAge(e.target.value)}
          sx={{
            flex: 2,
            maxWidth: 100,
            "& .MuiInputLabel-root": {
              top: "-16px",
            },

            "& .MuiInputBase-input": {
              fontSize: "0.85rem",
              padding: "2px 6px",
            },
          }}
        />
        <TextField
          label="Max Age"
          value={maxAge}
          onChange={(e) => setMaxAge(e.target.value)}
          sx={{
            flex: 2,
            maxWidth: 100,
            "& .MuiInputLabel-root": {
              top: "-16px",
            },

            "& .MuiInputBase-input": {
              fontSize: "0.85rem",
              padding: "2px 6px",
            },
          }}
        />
        <TextField
          select
          label="Gender"
          value={gender}
          onChange={(e) => setGender(e.target.value)}
          sx={{
            flex: 2,
            maxWidth: 120,
            "& .MuiInputLabel-root": {
              top: "-16px",
            },

            "& .MuiInputBase-input": {
              fontSize: "0.85rem",
              padding: "2px 6px",
            },
          }}
        >
          <MenuItem
            value="Male"
            sx={{ width: "100%", fontSize: "0.85rem", height: "26px" }}
          >
            Male
          </MenuItem>
          <MenuItem
            value="Female"
            sx={{ width: "100%", fontSize: "0.85rem", height: "26px" }}
          >
            Female
          </MenuItem>
          <MenuItem
            value="Both"
            sx={{ width: "100%", fontSize: "0.85rem", height: "26px" }}
          >
            Both
          </MenuItem>
        </TextField>
        <Button
          color="error"
          variant="dense"
          onClick={handleAdd}
          disabled={isDisabled}
        >
          Add
        </Button>
      </Box>
    </>
  );
}
